import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generatePaymentReceipt = (payment, tenant, property) => {
  const doc = new jsPDF();
  
  // Add header
  doc.setFontSize(20);
  doc.setTextColor(59, 130, 246); // Blue
  doc.text('RENT KOLLECT', 105, 20, { align: 'center' });
  
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text('PAYMENT RECEIPT', 105, 30, { align: 'center' });
  
  // Add receipt details
  doc.setFontSize(10);
  doc.text(`Receipt No: ${payment.id.substring(0, 8).toUpperCase()}`, 20, 45);
  doc.text(`Date: ${payment.payment_date}`, 150, 45);
  
  // Add line
  doc.setLineWidth(0.5);
  doc.line(20, 50, 190, 50);
  
  // Property details
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text('Property Details:', 20, 60);
  doc.setFont(undefined, 'normal');
  doc.setFontSize(10);
  doc.text(`Name: ${property?.name || 'N/A'}`, 20, 68);
  doc.text(`Address: ${property?.address || 'N/A'}`, 20, 75);
  
  // Tenant details
  doc.setFontSize(12);
  doc.setFont(undefined, 'bold');
  doc.text('Tenant Details:', 20, 90);
  doc.setFont(undefined, 'normal');
  doc.setFontSize(10);
  doc.text(`Name: ${tenant?.name || 'N/A'}`, 20, 98);
  doc.text(`Phone: ${tenant?.phone || 'N/A'}`, 20, 105);
  doc.text(`Email: ${tenant?.email || 'N/A'}`, 20, 112);
  
  // Payment details table
  doc.autoTable({
    startY: 125,
    head: [['Description', 'Details', 'Amount']],
    body: [
      ['Payment Type', payment.payment_type || 'N/A', ''],
      ['Payment Method', payment.payment_method || 'N/A', ''],
      ['Month', payment.month || 'N/A', ''],
      ['Transaction ID', payment.transaction_id || 'N/A', ''],
      ['', '', ''],
      ['', 'Total Amount', `₹${payment.amount.toLocaleString()}`]
    ],
    theme: 'grid',
    headStyles: { fillColor: [59, 130, 246] },
    footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' }
  });
  
  // Notes
  if (payment.notes) {
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(10);
    doc.setFont(undefined, 'bold');
    doc.text('Notes:', 20, finalY);
    doc.setFont(undefined, 'normal');
    doc.text(payment.notes, 20, finalY + 7);
  }
  
  // Footer
  const pageHeight = doc.internal.pageSize.height;
  doc.setFontSize(8);
  doc.setTextColor(128, 128, 128);
  doc.text('Thank you for your payment!', 105, pageHeight - 20, { align: 'center' });
  doc.text('This is a computer-generated receipt', 105, pageHeight - 15, { align: 'center' });
  
  // Save PDF
  const filename = `receipt_${payment.id.substring(0, 8)}_${payment.payment_date}.pdf`;
  doc.save(filename);
};

export const generateExpenseReport = (expenses) => {
  const doc = new jsPDF();
  
  // Add header
  doc.setFontSize(20);
  doc.setTextColor(59, 130, 246);
  doc.text('RENT KOLLECT', 105, 20, { align: 'center' });
  
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text('EXPENSE REPORT', 105, 30, { align: 'center' });
  
  doc.setFontSize(10);
  doc.text(`Generated: ${new Date().toLocaleDateString()}`, 105, 40, { align: 'center' });
  
  // Calculate totals
  const totalExpenses = expenses.reduce((sum, exp) => sum + exp.amount, 0);
  
  // Expenses table
  const tableData = expenses.map(exp => [
    exp.expense_date,
    exp.category,
    exp.description.substring(0, 40),
    exp.payment_method,
    `₹${exp.amount.toLocaleString()}`
  ]);
  
  tableData.push(['', '', '', 'TOTAL', `₹${totalExpenses.toLocaleString()}`]);
  
  doc.autoTable({
    startY: 50,
    head: [['Date', 'Category', 'Description', 'Method', 'Amount']],
    body: tableData,
    theme: 'grid',
    headStyles: { fillColor: [59, 130, 246] },
    footStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' }
  });
  
  // Save PDF
  doc.save(`expense_report_${new Date().toISOString().split('T')[0]}.pdf`);
};
